<template>

  <div
    data-app 
    class="container-fluid dmbs-header header-pad"
  >
    <v-toolbar flat color="transparent" height="50px">
      <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-xs-only">
            <v-btn small color="#ff0000" dark class="ml-1" style="height:30px" v-for="(lang, i) in idiomas" :key="`Lang${i}`" @click="setLocale(lang)">{{ $t(lang) }} </v-btn>
         </v-toolbar-items>  
          <v-toolbar-items class="hidden-sm-and-up">
            <v-btn small fab flat color="#ff0000" dark class="ml-1" v-for="(lang, i) in idiomas" :key="`Lang${i}`" @click="setLocale(lang)">{{ lang }} </v-btn>
         </v-toolbar-items>  
    </v-toolbar>
    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 dmbs-header-img text-left">
      <router-link v-if="$i18n.locale=='eu'" :to="`/${$i18n.locale}/`"><img
          class="hidden-xs"
          src="../../assets/cropped-K_entradas_hor_eus.jpg"
          height="102"
          width="241"
          alt="Kutxabank"
        ></router-link>
        <router-link v-else :to="`/${$i18n.locale}/`"><img
          class="hidden-xs"
          src="../../assets/cropped-K_entradas_hor_cas.jpg"
          height="102"
          width="241"
          alt="Kutxabank"
        ></router-link>
    </div>
    <div class="col-md-4 dmbs-header-text">
     </div>
      <div
        class="col-md-4 buscador dmbs-header-text"
      >

        <v-autocomplete
          outline
          class="mt-4 pa-1"
          :label="$t('Buscar Eventos')"
          :placerholder="$t('Buscar Eventos')"
          v-model="eventoBuscador"
          :items="eventosWeb"
          item-text="Nombre"
          hide-no-data
          hide-details
          item-value="webId"
          no-data-text="No existe el evento"
          @change="buscadorEventos"
        >
          <template
            slot="item"
            slot-scope="data"
          >
            <template>
              <v-list-tile-avatar
                tile
                avatar
              >
                <v-img
                  v-if="miImagen(data.item)"
                  :src="miImagen(data.item)"
                  aspect-ratio="1"
                ></v-img>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-text="data.item.Nombre"></v-list-tile-title>
                <v-list-tile-sub-title> {{data.item.Recinto[0].Nombre}} - {{data.item.Poblacion[0].Nombre}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </template>
        </v-autocomplete>
    </div>
  </div>
</template>
<style>
.buscador .theme--light.v-text-field--outline .v-input__slot {
  border: 1px solid rgba(0, 0, 0, 0.34);
  border-radius: 10px;
}
.buscador label.v-label.theme--light {
  font-size: 14px;
  font-weight: normal;
}
</style>

<script>
import { globales } from "../../components/comunes";
export default {
  mixins: [globales],
};
</script>
